import { render, staticRenderFns } from "./RequiredField.vue?vue&type=template&id=716a236c&scoped=true&"
import script from "./RequiredField.vue?vue&type=script&lang=js&"
export * from "./RequiredField.vue?vue&type=script&lang=js&"
import style0 from "./RequiredField.vue?vue&type=style&index=0&id=716a236c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a236c",
  null
  
)

export default component.exports